import { FC } from 'react';
import DataTablePager from '@srm/ui/data-table/pager';

interface AttachPagerProps {
    page: number;
    pageSize: number;
    totalCount: number;
    pagerSizes: number[];
    showPageSizeSelector: boolean;
    showInfo: boolean;
    onPageChange: (page: number) => void;
    onPageSizeChange: (size: number) => void;
}

/** Футер грида вложений — пейджер таблицы в классах `atb__*`. */
const AttachPager: FC<AttachPagerProps> = (props) => <DataTablePager classPrefix="atb" {...props} />;

export default AttachPager;
